// ------------ GLOBAL ------------ //
export const SET_LOAD = 'SET_LOAD';
export const CHANGE_THEME = 'CHANGE_THEME';
export const SET_TERMS_MODAL_VISIBLE = 'SET_TERMS_MODAL_VISIBLE';
export const SET_PRIVACY_MODAL_VISIBLE = 'SET_PRIVACY_MODAL_VISIBLE';

// ------------ REMITTANCE ------------ //
export const SET_REMITTANCE = 'SET_REMITTANCE';
export const CLEAN_REMITTANCE = 'CLEAN_REMITTANCE';

// ------------ REMITTANCE RESPONSE ------------ //
export const SET_REMITTANCE_RESPONSE = 'SET_REMITTANCE_RESPONSE';
export const CLEAN_REMITTANCE_RESPONSE = 'CLEAN_REMITTANCE_RESPONSE';

// ------------ USER ------------ //
export const SET_USER = 'SET_USER';

// ------------ CHAT ROOM ------------ //
export const SET_CHAT_ROOM = 'SET_CHAT_ROOM';

// ------------ CHANNEL ------------ //
export const SET_CHANNEL = 'SET_CHANNEL';
export const SET_CHANNELS_SEARCH = 'SET_CHANNELS_SEARCH';

// ------------ USERS ------------ //
export const SET_SEARCH_USERS = 'SET_SEARCH_USERS';

// ------------ ALERT ------------ //
export const SET_ALERT = 'SET_ALERT';

// ------------ REGISTRY ------------ //
export const SET_REGISTRY = 'SET_REGISTRY';
